// LOCAL
// export const SIGN_UP = "http://192.168.101.75:5067/api/Registration/UserRegistration";
// export const LOG_IN = "https://registration.tendertiger.co.in/api/Registration/Login_new";

// export const BASE_URLS = "http://192.168.101.75:5067/api";
// export const TENDERTIGER = "http://192.168.101.75:5067";


// LIVE
// export const SIGN_UP = "https://registration.tendertiger.co.in/api/Registration/UserRegistration";
//
//export tender="https://tendertiger.co.in"


export const BASE_URLS = "https://registration.tendertiger.co.in/api";
export const TENDERTIGER = "https://tendertiger.co.in";
export const WINDOW_HREF = window.location.href;
export const URL_INVOICE_DOWNLOAD = "http://202.65.135.214:5098/api/Invoice/Download";

// export const WINDOW_HREF = "beta.tendergpt.io";
// export const URL_INVOICE_DOWNLOAD = "http://192.168.100.153:8022/CRMAutoInvoice/api/Invoice/Download";
